/**
 * Validates a Brazilian CPF (with or without mask).
 *
 * The new CPF model allows alphanumeric characters, and the existing base
 * already contains alphanumeric CPFs, so we only enforce the length of 11
 * alphanumeric characters instead of the legacy numeric check-digit rule
 * (which would reject valid alphanumeric CPFs).
 */
export function isValidCpf(value?: string | null): boolean {
  if (!value) return false

  const normalized = value.replace(/[.\-\s]/g, '')
  return /^[a-zA-Z0-9]{11}$/.test(normalized)
}

/**
 * Validates a Brazilian RG number (with or without mask).
 * RG has no unified national format, so we accept 5–14 digits, optionally
 * ending with an "X" check character.
 */
export function isValidRg(value?: string | null): boolean {
  if (!value) return false

  const normalized = value.replace(/[.\-\s]/g, '')
  return /^\d{5,13}[\dxX]$/.test(normalized)
}
